// @flow

import * as React from 'react';
import { Switch as RRSwitch, Route } from 'react-router-dom';
import MissingPage from './MissingPage';

type Props = {
  children?: React.Node,
};

const Switch = ({ children }: Props) => (
  <RRSwitch>
    {children}
    <Route component={MissingPage} />
  </RRSwitch>
);

export default Switch;
